import { Component, Input} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-lock',
  imports: [
    MatIconModule,
    MatTooltipModule,
  ],
  templateUrl: './lock.component.html',
  styleUrl: './lock.component.scss'
})
export class LockComponent {
  @Input() lockedState?: boolean;
}
